import { blobToFile } from '@/utils';
import axiosClient from './api';
import EndPoints from './endpoints';
import { BackendUrl } from '@/utils/const';

export const uploadCvVidoCandidate = async (
  imageUrl: string,
  id: string,
): Promise<any> => {
  try {
    const data = new FormData();
    const Myblob = await fetch(`${imageUrl}`).then((res) => res.blob());
    const fileBlob = await fetch(
      `${BackendUrl}/uploads/candidate_${id}/final.mp4`,
    ).then((res) => res.blob());
    console.log('my blob', Myblob);

    const file = blobToFile(fileBlob, 'cv-video.mp4');
    const imageBlob = await fetch(
      `${BackendUrl}/uploads/candidate_${id}/0001.png`,
    ).then((res) => res.blob());
    const image = blobToFile(imageBlob, 'image_001.png');

    data.append('file', file);
    data.append('file', image);

    if (id) {
      const response = await axiosClient.post(
        `${EndPoints.CvVideo.uploadCvVideo(Number(id))}`,
        data,
      );
      if (response) return response;
    }
  } catch (error) {
    console.log('upload final video', error);
  }
};

export const uploadVideStep = async (fileVideoBlob: any, id: any) => {
  try {
    const file = blobToFile(fileVideoBlob, 'video.mp4');

    const formdata = new FormData();
    formdata.append('file', file, 'b2.mp4');

    const requestOptions: any = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
    };

    const response = await fetch(
      `${BackendUrl}/upload-cv-video/${id}`,
      requestOptions,
    );
    if (response) {
      return await response.json();
    }
  } catch (e) {
    console.log('meee error upload step', e);
  }
};

export const uploadMergeVideo = async (fileVideoBlob: any, id: any) => {
  try {
    const file = blobToFile(fileVideoBlob, 'video.mp4');

    const formdata = new FormData();
    formdata.append('file', file, 'b2.mp4');

    const requestOptions: any = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
    };

    const res = await fetch(
      `${BackendUrl}/upload-final-cv-video/${id}`,
      requestOptions,
    );
    return res.status;
  } catch (e) {
    console.log('meee error merge steps', e);
  }
};

export const DeleteFinalCvVideo = async (id: any) => {
  const formdata = new FormData();
  const requestOptions: any = {
    method: 'POST',
    body: formdata,
    redirect: 'follow',
  };

  fetch(`${BackendUrl}/remove-final-cv-video/${id}`, requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));
};
export const deleteImages = (id: any) => {
  const formdata = new FormData();
  const requestOptions: any = {
    method: 'POST',
    body: formdata,
    redirect: 'follow',
  };

  fetch(`${BackendUrl}/remove-image-cv-video/${id}`, requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));
};
export const uploadImage = async (
  fileVideoBlob: any,
  imageName: string,
  id: any,
) => {
  const file = blobToFile(fileVideoBlob, imageName);

  const formdata = new FormData();
  formdata.append('file', file, file.name);
  const requestOptions: any = {
    method: 'POST',
    body: formdata,
    redirect: 'follow',
  };

  const res = await fetch(`${BackendUrl}/upload-image/${id}`, requestOptions);
  return res.status;
};

export const createFolderCandidate = async (id: any) => {
  const formdata = new FormData();
  const requestOptions: any = {
    method: 'POST',
    body: formdata,
    redirect: 'follow',
  };

  const res = await fetch(
    `${BackendUrl}/create_folder_cv/${id}`,
    requestOptions,
  );
  return res.status;
};
export const deletePhoto = async (id: any) => {
  const formdata = new FormData();
  const requestOptions: any = {
    method: 'POST',
    body: formdata,
    redirect: 'follow',
  };

  const res = await fetch(
    `${BackendUrl}/delete-photo-tacked/${id}`,
    requestOptions,
  );
  return res.status;
};
